export const SHARED_CONFIG = {
  ANONYMOUS_USER_ID: 'anonymous',
}